import { MarkerClusterer } from "@googlemaps/markerclusterer";
import {
  DeviceListingResponse,
  DeviceListingResponseWAddress,
} from "../../../api/types/Camera";
import svgIcons from "../../../assets/svg/svgIcons";
import { mapVehicleIconWrapped } from "../../../assets/svg/vehicle-wrapped";
import { APP_CONFIG } from "../../../constants/constants";
import { TMapVehicleIconState } from "../../../types/map";
import { CustomRenderer } from "../../../utils/map";
import { getAccountMapIconSizeMultiplierNoHook } from "../../../utils/user";
import { TMapOperations, TMPushpin } from "./type";

export const mapOperations: TMapOperations = (props) => {
  console.log("[mapOperations]", props);
  const google = (window as any).google;

  // create a namespace for map objects
  props.mapRef.current.objects = {
    mPushpins: [],
    mClusterLayer: null,
  };

  const motionIconSize = APP_CONFIG.MAPS.VEHICLE_EVENT_ICON_SIZE;
  const eventIconSize = APP_CONFIG.MAPS.VEHICLE_EVENT_ICON_SIZE * 1.6;

  const renderMapObjects = async () => {
    const MAX_WAYPOINTS = 25;
    const MAX_VIAPOINTS = 10;
    const G_MAX_WAYPOINTS = 25;
    const { AdvancedMarkerElement } =
      await google?.maps?.importLibrary("marker");
    const map = props.mapRef.current.map;
    // determine snapped points and save them to LS - to prevent repeated calls
    // finally use snapped points to create waypoints

    const tripEventMarkerArr: any[] = [];

    props.dataPoints
      // .filter((tripPoint) => cameraPoint.length > 1)
      .forEach((cameraPoint, pointIndex) => {
        const displayEventPointOnMap = (
          sanitizedTripPoint: DeviceListingResponse
        ) => {
          const isMotionEvent = false;
          // cameraPoint.statuscode ===
          //   VehicleStatusCode.STATUS_MOTION_HEADING ||
          // cameraPoint.statuscode ===
          //   VehicleStatusCode.STATUS_MOTION_MOVING ||
          // cameraPoint.statuscode ===
          //   VehicleStatusCode.STATUS_MOTION_ENROUTE;
          // || cameraPoint.statuscode === VehicleStatusCode.STATUS_MOTION_EN_ROUTE // typescript giving unintentional comparison error here probably because STATUS_MOTION_ENROUTE is equal to STATUS_MOTION_EN_ROUTE

          let icon = null;

          icon = mapVehicleIconWrapped(
            mapVehicleStateIconSlugVM(cameraPoint),
            false,
            45,
            APP_CONFIG.MAPS.VEHICLE_ICON_SIZE *
              getAccountMapIconSizeMultiplierNoHook(), // size
            false, // onlyIcon
            false, // highlightIcon
            cameraPoint, //  dataPoint
            props.isAssetImageEnabled
          );

          // create a pushpin for the trip point event
          // Set anchor point based on motion or event status
          const anchorPoint = isMotionEvent
            ? { x: motionIconSize * 0.5, y: motionIconSize * 0.5 }
            : { x: eventIconSize * 0.5, y: eventIconSize * 0.8 };
          const parseSvgToDom = (svgString: string) => {
            const parser = new DOMParser();
            return parser.parseFromString(svgString, "image/svg+xml")
              .documentElement;
          };
          const pinSvg = parseSvgToDom(icon);
          // Create the marker
          const tripEventMarker = new AdvancedMarkerElement({
            position: {
              lat: cameraPoint.ft_lastvalidlatitude,
              lng: cameraPoint.ft_lastvalidlongitude,
            },
            map,
            content: pinSvg,
            title: `${cameraPoint.device_id || ""}`, // used to identify which markers fall under a cluster and show infobox accordingly
          });

          // this auxMarker is meant for debugging and should be enabled only if debugging is required
          // const auxMarker = new google.maps.Marker({
          //   position: {
          //     lat: cameraPoint.latitude,
          //     lng: cameraPoint.longitude,
          //   },
          //   map: map,
          // });
          // auxMarker.setMap(map);

          // Apply anchor (offset) using CSS transform
          // 3/26/2025 Disabled the transform styles below as this is causing the dot to be off the actual location
          // tripEventMarker.content.style.transform = `translate(-${anchorPoint.x}px, -${anchorPoint.y}px)`;
          // 4/4/2024 following style helps to position the marker correctly
          if (isMotionEvent) {
            // to position the enroute arrow icon correctly
            tripEventMarker.content.style.transform = "translateY(50%)";
          } else {
            // to position other event icons (white marker shape) correctly
            tripEventMarker.content.style.transform = "translateY(15%)";
          }

          // open an infowindow with details
          const headerContent = document.createElement("h4");
          headerContent.className =
            "ps-4 text-base font-semibold text-accent-blue-dark";
          headerContent.innerHTML = Array.from(
            new Set([
              cameraPoint.serial_number,
              cameraPoint.ft_device_id, // cameraPoint.unit_name,
              cameraPoint.ft_device_description,
            ])
          )
            .filter((item) => !!item)
            .join(" | ");
          const infobox = new google.maps.InfoWindow({
            content: mapDeviceEventInfoBoxContent(cameraPoint),
            // headerDisabled: true,
            headerContent,
            maxWidth: 300,
            // pixelOffset: new google.maps.Size(16, -16),
            zIndex: APP_CONFIG.MAPS.INFOBOX_ZINDEX,
          });

          // Add click event listener
          tripEventMarker.addEventListener("click", () => {
            props.onDataPointPushpinClick?.(cameraPoint);
            // show infobox on click
            infobox.open({
              anchor: tripEventMarker,
              map: map,
            });
          });

          // close infowindow on clicking anywhere on the map
          // google.maps.event.addListener(map, "click", function () {
          //   infobox.close();
          // });

          // add the pushpin to the objects
          const pushpinObject: TMPushpin = {
            index: pointIndex,
            recordId: `${cameraPoint.device_id || ""}`, // or any unique property value
            marker: tripEventMarker,
            pointData: cameraPoint,
            infobox: infobox,
          };
          props.mapRef.current.objects.mPushpins.push(pushpinObject);

          tripEventMarkerArr.push(tripEventMarker);
        };

        displayEventPointOnMap(cameraPoint);
      });

    // if clustering is enabled...
    // Create a ClusterLayer and add it to the map.
    if (props.mapLayerOptions?.clustering) {
      new MarkerClusterer({
        markers: tripEventMarkerArr,
        map: map,
        renderer: new CustomRenderer(
          props.dataPoints as DeviceListingResponse[],
          "cameras"
        ),
      });
    }

    // center the map to the polygon
    setTimeout(() => mapCenterToDataPoints(props, props.dataPoints), 1000);

    // set global object
    (window as any).map = props.mapRef.current;

    return null;
  };
  renderMapObjects();
};

const mapCenterToDataPoints: TMapOperations = async (props, value) => {
  const google = window.google;
  const googleMapsCore: any = await google?.maps?.importLibrary?.("core");
  if (!googleMapsCore || !googleMapsCore.LatLngBounds) return;
  const { LatLngBounds } = googleMapsCore;
  if (!props.dataPoints || props.dataPoints.length < 1) return;
  const bounds = new LatLngBounds();
  props.dataPoints
    // .reduce((acc, trip, index) => {
    //   if (
    //     props?.selectedTripIndex === null ||
    //     index === props?.selectedTripIndex
    //   ) {
    //     acc.push(...trip);
    //   }
    //   return acc;
    // }, [])
    .forEach((dataPoint) => {
      bounds.extend(
        new google.maps.LatLng(
          dataPoint.ft_lastvalidlatitude,
          dataPoint.ft_lastvalidlongitude
        )
      );
    });

  if (!bounds.isEmpty()) {
    props.mapRef.current.map?.fitBounds(bounds, 20);
  }
};

export const mapDeviceEventInfoBoxContent = (
  dataPoint: DeviceListingResponseWAddress
) => {
  return (
    `<div class="vehicle-infobox-content bg-white Xoutline -outline-offset-2 outline-accent-blue-dark/20 rounded-lg text-sm leading-none break-all flex flex-col min-w-56 px-4 pb-4 relative">` +
    // <!-- h4 class="pt-2 font-semibold text-accent-blue-dark">${dataPoint.status.description}</h4 -->
    (!!dataPoint.device_id
      ? !!dataPoint.ft_lastvalidlatitude && dataPoint.ft_lastvalidlongitude
        ? `<p class="pt-2 flex items-center gap-3"><img src="${svgIcons.CameraEventSpecLocation}" />${dataPoint?.formatted_address || `${dataPoint.ft_lastvalidlatitude}, ${dataPoint.ft_lastvalidlongitude}`}</p>`
        : "" // +
      : // (!!dataPoint.ft_device_id
        //   ? `<p class="pt-2 flex items-center gap-3"><img src="${svgIcons.CameraEventSpecCamera}" />${dataPoint.ft_device_id}</p>`
        //   : "") +
        // `<p class="pt-2 flex items-center gap-3">` +
        // `${Array.from(new Set([dataPoint.ft_device_id, dataPoint.is_online]))
        //   .filter((item) => !!item)
        //   .join(" | ")}` +
        // `</p>`
        "") +
    `</div>`
  );
};

// helper function to map vehicle state icon slug
export const mapVehicleStateIconSlugVM: (
  dataPoint: DeviceListingResponse | undefined
) => TMapVehicleIconState = (dataPoint: DeviceListingResponse | undefined) => {
  switch ((dataPoint as DeviceListingResponse)?.camera_dashboard_status) {
    case "not_reporting":
      return "offline";
    case "live":
      return "idle_active";
    case "standby":
      return "ignition_off";
    default:
      return "offline";
  }
};
